import { Route } from 'react-router-dom';
import { MentorCalendarConnect } from "../pages/MentorCalendarConnect/index";
import { MentorAvailability } from "../pages/MentorAvailability/index";
import { GoogleOAuthProvider } from '@react-oauth/google';

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;

export const mentorRoutes = [
  <Route 
    key="mentor-connect" 
    path="find-time/:sessionId/mentor/:mentorId/connect" 
    element={
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <MentorCalendarConnect />
      </GoogleOAuthProvider>
    }
  />,
  <Route 
    key="mentor-availability" 
    path="find-time/:sessionId/mentor/:mentorId/availability" 
    element={
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <MentorAvailability />
      </GoogleOAuthProvider>
    }
  />,
];